import { animated, useTrail } from "react-spring";

import AwardsItem from "../AwardsItem";
import { AwardsItemProps } from "../AwardsItem/AwardsItem";
import React from "react";

export interface AwardsListProps {
  awards: AwardsItemProps[];
}

const AwardsList = ({ awards }: AwardsListProps) => {
  // Fade in up animation
  const fadeInUpTrail = useTrail(awards.length, {
    opacity: 1,
    transform: "translateY(0px)",
    from: {
      opacity: 0,
      transform: "translateY(10px)",
    },
  });

  return (
    <div className="w-full space-y-8">
      {awards.map((award, key) => (
        <animated.div style={fadeInUpTrail[key]} key={key}>
          <AwardsItem {...award} />
        </animated.div>
      ))}
    </div>
  );
};

export default AwardsList;
